import { XMarkIcon } from '@heroicons/react/20/solid'
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {addCartItem} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";

export default function PromotionalBanner({shouldShowPremium}) {
    const [isOpen, setIsOpen] = useState(true)
    const navigate = useNavigate()

    return (
        <div>
            {
                isOpen &&
                    <div className="flex items-center gap-x-6 bg-gray-900 px-6 py-2.5 sm:px-3.5 sm:before:flex-1 cursor-pointer"
                         onClick={() => {
                             window.location.href = "https://app.pabloo.com/sign-up"
                             sendSlackMessageTracked("Visitor clicked on main banner.")
                         }}
                    >
                        <p className="text-sm text-white w-full flex justify-center items-center">

                            {
                                Boolean(shouldShowPremium) &&
                                <div>
                                    <strong className="font-semibold">Go Premium</strong> &nbsp;<span
                                    aria-hidden="true">&rarr;</span>
                                </div>
                            }


                            {
                                !Boolean(shouldShowPremium) &&
                                <div>
                                    🏆 World Cup season. America turns 250. The biggest sales summer ever —&nbsp;<strong className="font-semibold">Go Pro now</strong> &nbsp;<span
                                    aria-hidden="true">&rarr;</span>
                                </div>
                            }

                        </p>
                        {/*<div className="flex flex-1 justify-end">*/}
                        {/*    <button type="button" className="-m-3 p-3 focus-visible:outline-offset-[-4px]" onClick={() => setIsOpen(false)}>*/}
                        {/*        <span className="sr-only">Dismiss</span>*/}
                        {/*        <XMarkIcon aria-hidden="true" className="size-5 text-white"/>*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                    </div>
            }
        </div>
    )
}
